<template>
  <ak-select
    v-model="visualSchedule.patients"
    :selected="visualSchedule.patients"
    :options="fetchedPatients"
    @search="fetchPatientOptions"
    :taggable="true"
    label="name"
    :filterable="false"
    :multiple="true"
    placeholder="Search your patients..."
    aria-label="Search your patients..."
    @close="updatePatients"
    @option:deselected="updatePatients"
    @option:selected="updatePatients"
  >
    <template slot="no-options"> Type 2 or more characters</template>
  </ak-select>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import AkSelect from '../../components/select.vue';

export default {
  components: { AkSelect },

  data() {
    return {
      fetchedPatients: [],
    };
  },

  computed: {
    ...mapState(['userId', 'visualSchedule']),
  },

  methods: {
    async updatePatients() {
      try {
        await axios.patch(`/api/v2/visual-schedules/${this.visualSchedule.id}`, {
          visual_schedule: this.visualSchedule,
        });
        this.$toast.open('Patients updated!');
      } catch {
        this.$toast.open({ type: 'error', message: 'Something went wrong. Try again' });
      }
    },
    fetchPatientOptions(search, loading) {
      if (search.length < 2) return;

      loading(true);
      axios.get(`/api/v2/patients?q=${encodeURIComponent(search)}`).then((response) => {
        this.fetchedPatients = response.data;
        loading(false);
      });
    },
  },
};
</script>
